import { getLogger } from "@elixir/telemetry-js";
const APP_NAME = "EscalationsHub-UI";
function buildContext(context) {
    return Object.assign({ name: context.action, app: APP_NAME }, context);
}
/**
 * Log an error. Sent to App Insights as Exception in deployed environments.
 */
export const logError = (message, context) => {
    getLogger().error(new Error(message), false, buildContext(context));
};
/**
 * Log a warning. Sent to App Insights as Warning in deployed environments.
 */
export const logWarning = (message, context) => {
    getLogger().warn(new Error(message), buildContext(context));
};
/**
 * Log a custom event for analytics/tracking.
 * Sent to App Insights as Custom Event in deployed environments.
 */
export const logEvent = (name, context) => {
    getLogger().event(name, Object.assign({ app: APP_NAME }, context));
};
/**
 * Log a trace for diagnostics.
 * Sent to App Insights as Trace in deployed environments.
 */
export const logTrace = (message, context) => {
    getLogger().trace(message, Object.assign({ app: APP_NAME }, context));
};
